import { Currency } from '@/core/currency/interfaces';

const DZD: Currency = {
    name: 'Algerian Dinar',
    demonym: 'Algerian',
    majorSingle: 'Dinar',
    majorPlural: 'Dinars',
    codeNumeric: '012',
    symbol: 'DA',
    symbolNative: 'د.ج.',
    minorSingle: 'Santeem',
    minorPlural: 'Santeems',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'DZD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default DZD;
